import { ArrowRight, MapPin, Users, Star, Globe, ArrowDown } from "lucide-react";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { StickyHeader, Footer } from "../../intro/components/landing-new";
import { pastLeaders } from "../../constants/leaders";

const GroupLeaderInfo = () => {
  const navigate = useNavigate();
  return (
    <>
      <StickyHeader />
      <div className="tw-min-h-screen tw-font-sans">
        {/* Hero Section with Parallax Effect */}
        <section className="tw-relative tw-h-[calc(100vh)] tw-overflow-hidden">
          <div
            className="tw-absolute tw-inset-0 tw-scale-110 tw-transform tw-bg-cover tw-bg-center"
            style={{
              backgroundImage:
                "url('https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/151028Copy%20of%20IMG_4012.JPG')",
              transform: "translateZ(-1px) scale(1)",
            }}
          />
          <div className="tw-absolute tw-inset-0 tw-bg-black/40" />
          <div className="tw-absolute tw-left-4 tw-right-4 tw-top-[calc(48px+68px)] tw-z-10 md:tw-left-[15%] md:tw-right-[15%] md:tw-top-[30vh]">
            <h1 className="tw-text-center tw-text-[22px] tw-font-extrabold tw-text-white md:tw-text-5xl">
              Lead adventures,
              <br />
              create stories
            </h1>
            <p className="tw-text-center tw-text-[12px] tw-font-semibold tw-text-white md:tw-text-2xl">
              Join our community of passionate trip leaders and shape unforgettable experiences
            </p>
          </div>
          {/* <div className="tw-absolute tw-bottom-[calc(24px+84px)] tw-left-4 tw-right-4 tw-z-10 md:tw-bottom-[20vh] md:tw-left-[15%] md:tw-right-[15%]">
            <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-text-white md:tw-flex-row md:tw-gap-8">
              <button
                onClick={() => navigate("/group-leader/apply")}
                className="hover:tw-bg-primary-dark tw-rounded-full tw-bg-primary-main tw-px-6 tw-py-3 tw-text-base tw-font-bold tw-text-white tw-transition-colors md:tw-px-10 md:tw-py-4 md:tw-text-lg"
              >
                Start your journey
              </button>
            </div>
          </div> */}
        </section>

        {/* Who is this for Section */}
        <section className="tw-bg-white tw-px-4 tw-py-[40px] md:tw-px-16 md:tw-py-16 lg:tw-px-24">
          <div className="tw-text-center tw-text-[26px] tw-font-extrabold md:tw-text-[32px]">
            Who are we looking for?
          </div>
          <div className="tw-mb-8 tw-text-center tw-text-base tw-font-semibold tw-text-primary-main md:tw-mb-12 md:tw-text-lg">
            Join our community of passionate trip leaders
          </div>
          <div className="tw-mx-auto tw-grid tw-max-w-4xl tw-gap-6 md:tw-grid-cols-2">
            <div className="tw-rounded-2xl tw-bg-white tw-p-6 tw-shadow-md tw-transition-shadow tw-duration-300 hover:tw-shadow-lg">
              <div className="tw-flex tw-items-start tw-space-x-4">
                <div className="tw-flex tw-h-12 tw-w-12 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-main">
                  <Star className="tw-h-6 tw-w-6 tw-text-white" />
                </div>
                <div>
                  <h3 className="tw-mb-2 tw-text-[22px] tw-font-bold tw-text-gray-900">
                    Contagious energy
                  </h3>
                  <p className="tw-text-base tw-leading-relaxed tw-text-gray-600">
                    Being around you feels like the best part of the trip. You know when to push for
                    excitement and when to pull back for rest. If you're the kind of person who
                    builds connections naturally, this is your opportunity to lead trips that leave
                    lifelong impressions.
                  </p>
                </div>
              </div>
            </div>
            <div className="tw-rounded-2xl tw-bg-white tw-p-6 tw-shadow-md tw-transition-shadow tw-duration-300 hover:tw-shadow-lg">
              <div className="tw-flex tw-items-start tw-space-x-4">
                <div className="tw-flex tw-h-12 tw-w-12 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-main">
                  <Users className="tw-h-6 tw-w-6 tw-text-white" />
                </div>
                <div>
                  <h3 className="tw-mb-2 tw-text-[22px] tw-font-bold tw-text-gray-900">
                    Relatable and dependable
                  </h3>
                  <p className="tw-text-base tw-leading-relaxed tw-text-gray-600">
                    You're the one who brings warmth and comfort, making sure no one feels left out.
                    It's not about planning every detail—it's about being responsible and genuinely
                    caring for others. Whether it's lifting spirits or helping out when it's needed
                    most, you're the glue that keeps the group connected and thriving.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section
          className="tw-relative tw-bg-cover tw-bg-center tw-px-4 tw-py-[40px] md:tw-px-16 md:tw-py-16 lg:tw-px-24"
          style={{
            backgroundImage:
              "url('https://www.nepalsanctuarytreks.com/wp-content/uploads/2019/12/DSC_0474.jpg.webp')",
          }}
        >
          <div className="tw-absolute tw-inset-0 tw-bg-black/50"></div>
          <div className="tw-container tw-relative tw-mx-auto">
            <div className="tw-mb-8 tw-text-center tw-text-[26px] tw-font-extrabold tw-text-white md:tw-mb-12 md:tw-text-[32px]">
              Our growing community
            </div>
            <div className="tw-flex tw-flex-wrap tw-justify-center tw-gap-6">
              <div className="tw-w-[300px] tw-rounded-2xl tw-bg-white/90 tw-px-8 tw-py-6 tw-shadow-lg tw-backdrop-blur-sm">
                <div className="tw-text-[32px] tw-font-extrabold tw-text-primary-main">50+</div>
                <div className="tw-text-base tw-font-semibold tw-text-gray-700">
                  Active trip Leaders
                </div>
              </div>
              <div className="tw-w-[300px] tw-rounded-2xl tw-bg-white/90 tw-px-8 tw-py-6 tw-shadow-lg tw-backdrop-blur-sm">
                <div className="tw-text-[32px] tw-font-extrabold tw-text-primary-main">200+</div>
                <div className="tw-text-base tw-font-semibold tw-text-gray-700">
                  Trips completed
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* What Trip Leaders Do Section */}
        <section className="tw-bg-white tw-px-4 tw-py-[40px] md:tw-px-16 md:tw-py-16 lg:tw-px-24">
          <div className="tw-text-center tw-text-[26px] tw-font-extrabold md:tw-text-[32px]">
            What group leaders do
          </div>
          <div className="tw-mb-8 tw-text-center tw-text-base tw-font-semibold tw-text-primary-main md:tw-mb-12 md:tw-text-lg">
            Simple yet impactful responsibilities
          </div>
          <div className="tw-mx-auto tw-grid tw-max-w-6xl tw-gap-6 md:tw-grid-cols-2 lg:tw-grid-cols-3">
            <div className="tw-rounded-2xl tw-bg-white tw-p-6 tw-shadow-md tw-transition-shadow tw-duration-300 hover:tw-shadow-lg">
              <div className="tw-mb-4 tw-flex tw-items-center tw-gap-4">
                <div className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-main/10">
                  <Users className="tw-h-6 tw-w-6 tw-text-primary-main" />
                </div>
                <h3 className="tw-text-[22px] tw-font-bold tw-text-gray-900">Simple admin tasks</h3>
              </div>
              <p className="tw-text-base tw-leading-relaxed tw-text-gray-600">
                Set meeting points and communicate the group needs with our guides
              </p>
            </div>
            <div className="tw-rounded-2xl tw-bg-white tw-p-6 tw-shadow-md tw-transition-shadow tw-duration-300 hover:tw-shadow-lg">
              <div className="tw-mb-4 tw-flex tw-items-center tw-gap-4">
                <div className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-main/10">
                  <Star className="tw-h-6 tw-w-6 tw-text-primary-main" />
                </div>
                <h3 className="tw-text-[22px] tw-font-bold tw-text-gray-900">Bring the vibe</h3>
              </div>
              <p className="tw-text-base tw-leading-relaxed tw-text-gray-600">
                Create a fun, easy-going, and open atmosphere for the group
              </p>
            </div>
            <div className="tw-rounded-2xl tw-bg-white tw-p-6 tw-shadow-md tw-transition-shadow tw-duration-300 hover:tw-shadow-lg">
              <div className="tw-mb-4 tw-flex tw-items-center tw-gap-4">
                <div className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-main/10">
                  <Globe className="tw-h-6 tw-w-6 tw-text-primary-main" />
                </div>
                <h3 className="tw-text-[22px] tw-font-bold tw-text-gray-900">
                  Handle simple issues
                </h3>
              </div>
              <p className="tw-text-base tw-leading-relaxed tw-text-gray-600">
                Help to resolve simple issues with our guides and surface it to us if required.
              </p>
            </div>
          </div>
        </section>

        {/* Journey Timeline - With Arrows */}
        <section className="tw-relative tw-bg-gradient-to-b tw-from-gray-50 tw-to-gray-100 tw-py-10">
          <div className="tw-absolute tw-inset-0 tw-opacity-10">
            <img
              src="/patterns/world-map.svg"
              alt=""
              className="tw-h-full tw-w-full tw-object-cover"
            />
          </div>
          <div className="tw-container tw-relative tw-mx-auto tw-px-4">
            <h2 className="tw-mb-6 tw-text-center tw-text-[26px] tw-font-bold md:tw-text-[34px]">
              Group leader journey
            </h2>
            <div className="tw-relative tw-mx-auto tw-max-w-4xl">
              <div className="tw-absolute tw-left-[3%] tw-z-10 tw-h-full tw-w-1 -tw-translate-x-1/2 tw-transform tw-bg-[#00BFFF] md:tw-left-[25%]">
                <div className="tw-absolute -tw-top-2 tw-left-1/2 tw-h-4 tw-w-4 -tw-translate-x-1/2 tw-rounded-full tw-bg-[#00BFFF]"></div>
                <div className="tw-absolute -tw-bottom-2 tw-left-1/2 tw-h-4 tw-w-4 -tw-translate-x-1/2 tw-rounded-full tw-bg-[#00BFFF]"></div>
              </div>
              <div className="tw-space-y-4 md:tw-space-y-8">
                <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                  {!isMobile && (
                    <div className="tw-absolute tw-left-[3%] tw-z-10 -tw-translate-x-1/2 tw-transform md:tw-left-[25%]">
                      <ArrowDown className="tw-h-8 tw-w-8 tw-font-bold tw-text-[#00BFFF]" />
                    </div>
                  )}
                  <div className="tw-pl-[calc(3%+2rem)] md:tw-w-[700px] md:tw-pl-[calc(25%+2rem)]">
                    <div className="tw-rounded-xl tw-bg-white/90 tw-p-6 tw-shadow-md tw-backdrop-blur">
                      <h3 className="tw-mb-2 tw-text-[22px] tw-font-semibold tw-text-[#00BFFF]">
                        Group leader 👼
                      </h3>
                      <p className="tw-text-[16px] tw-font-bold tw-text-gray-600">
                        Get 25% off first trip, 50% off second
                      </p>
                      <ul className="tw-mt-4 tw-list-inside tw-list-disc tw-text-[16px] tw-text-gray-600">
                        <li>Handle simple admin tasks</li>
                        <li>Build confidence</li>
                        <li>Feel the vibe</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <p className="tw-text-center tw-italic tw-text-gray-600">
                  After successfully leading two trips
                </p>

                <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                  <div className="tw-absolute tw-left-[3%] tw-z-10 -tw-translate-x-1/2 tw-transform md:tw-left-[25%]">
                    <ArrowDown className="tw-h-8 tw-w-8 tw-font-bold tw-text-[#00BFFF]" />
                  </div>
                  <div className="tw-pl-[calc(3%+2rem)] md:tw-w-[700px] md:tw-pl-[calc(25%+2rem)]">
                    <div className="tw-rounded-xl tw-bg-white/90 tw-p-6 tw-shadow-md tw-backdrop-blur">
                      <h3 className="tw-mb-2 tw-text-[22px] tw-font-semibold tw-text-[#00BFFF]">
                        Invite-only: Leader bootcamp 🏔
                      </h3>
                      <p className="tw-text-[16px] tw-font-bold tw-text-gray-600">
                        Level up your skills in our 1-day in-person bootcamp where you will learn
                        to:
                      </p>
                      <ul className="tw-mt-4 tw-list-inside tw-list-disc tw-text-[16px] tw-text-gray-600">
                        <li>Master safety & trip organization</li>
                        <li>Engineer connections & create inviting social circles</li>
                        <li>Capture precious memories through photos & videos</li>
                        <li>Represent our brand & manage trip challenges</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <p className="tw-text-center tw-italic tw-text-gray-600">
                  Get promoted to super leader
                </p>

                <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                  <div className="tw-absolute tw-left-[3%] tw-z-10 -tw-translate-x-1/2 tw-transform md:tw-left-[25%]">
                    <ArrowDown className="tw-h-8 tw-w-8 tw-font-bold tw-text-[#00BFFF]" />
                  </div>
                  <div className="tw-pl-[calc(3%+2rem)] md:tw-w-[700px] md:tw-pl-[calc(25%+2rem)]">
                    <div className="tw-rounded-xl tw-bg-white/90 tw-p-6 tw-shadow-md tw-backdrop-blur">
                      <h3 className="tw-mb-2 tw-text-[22px] tw-font-semibold tw-text-[#00BFFF]">
                        Super leader 🏆
                      </h3>
                      <p className="tw-text-[16px] tw-font-bold tw-text-gray-600">
                        Lead trips for free and mentor new leaders
                      </p>
                      <ul className="tw-mt-4 tw-list-inside tw-list-disc tw-text-[16px] tw-text-gray-600">
                        <li>Free trips as leader</li>
                        <li>Priority access to new trips</li>
                        <li>Shape the community</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Meet Our Leaders */}
        <section className="tw-bg-white tw-px-4 tw-py-[40px] md:tw-px-16 md:tw-py-16 lg:tw-px-24">
          <div className="tw-text-center tw-text-[26px] tw-font-extrabold md:tw-text-[32px]">
            Meet our group leaders
          </div>
          <div className="tw-mb-8 tw-text-center tw-text-base tw-font-semibold tw-text-primary-main md:tw-mb-12 md:tw-text-lg">
            Hear from our passionate community members
          </div>
          <div className="tw-mx-auto tw-grid tw-max-w-[1200px] tw-grid-cols-1 tw-gap-6 md:tw-grid-cols-2 lg:tw-grid-cols-3">
            {pastLeaders.map((leader, index) => (
              <div
                key={index}
                className="tw-group tw-relative tw-h-[440px] tw-overflow-hidden tw-rounded-2xl"
              >
                <img
                  src={leader.image || "/placeholder.svg"}
                  alt={leader.name}
                  className="tw-h-full tw-w-full tw-object-cover tw-transition tw-duration-300 group-hover:tw-scale-105"
                />
                <div className="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-justify-end tw-bg-gradient-to-t tw-from-black/80 tw-via-black/50 tw-to-transparent tw-p-6">
                  <h3 className="tw-mb-2 tw-text-[22px] tw-font-bold tw-text-white">
                    {leader.name}
                  </h3>
                  <p className="tw-text-base tw-leading-relaxed tw-text-gray-200">{leader.quote}</p>
                  {leader.location && (
                    <div className="tw-mt-3 tw-flex tw-items-center tw-text-gray-300">
                      <MapPin className="tw-mr-2 tw-h-5 tw-w-5" />
                      <span className="tw-text-base">{leader.location}</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Final CTA */}
        <section className="tw-bg-primary-main tw-px-4 tw-py-[40px] md:tw-px-16 md:tw-py-16 lg:tw-px-24">
          <div className="tw-mx-auto tw-max-w-[1200px] tw-text-center">
            <div className="tw-mb-3 tw-text-[26px] tw-font-extrabold tw-text-white md:tw-text-[32px]">
              Ready to lead amazing adventures?
            </div>
            <p className="tw-mx-auto tw-mb-8 tw-max-w-2xl tw-text-base tw-font-semibold tw-text-white/90 md:tw-mb-12 md:tw-text-lg">
              Join our community of passionate trip leaders and start creating unforgettable
              experiences
            </p>
            <button
              // onClick={() => navigate("/group-leader/apply")}
              className="tw-mx-auto tw-flex tw-items-center tw-rounded-full tw-bg-white tw-px-6 tw-py-3 tw-text-base tw-font-bold tw-text-primary-main tw-transition-colors hover:tw-bg-gray-50 md:tw-px-10 md:tw-py-4 md:tw-text-lg"
            >
              Apply now (Coming soon)
              <ArrowRight className="tw-ml-2 tw-h-5 tw-w-5" />
            </button>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default GroupLeaderInfo;
